import React, { useState, useRef, useEffect } from "react";
import {
  Button,
  DatePicker,
  Form,
  Input,
  Select,
  Switch,
  Col,
  Row,
  Card,
  Space,
  Tabs,
  Popconfirm,
  Typography,
  InputNumber,
  Upload,
  message,
  Flex,
  Drawer,
  Spin,
  Dropdown,
} from "antd";
import Table from 'components/Common/Table';
import fileDownload from "js-file-download";
import * as adminactions from "store/actions/AuthActions";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { loadCountries, loadStates } from "store/slices/MasterSlice";
import {
  InboxOutlined,
  DeleteOutlined,
  DownloadOutlined,
  PrinterOutlined,
  EyeOutlined,
  ReloadOutlined,
  LinkOutlined,
  EditOutlined,
  CopyOutlined,
  DownOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import PdfPreviewModal from "components/PdfPreviewModal/PdfPreviewModal";
import {
  downloadDocumentFile,
  getDocument,
  getDocumentFileUrl,
  getDocumentPreviewSource,
} from "utils/documentFile";
import CloneInvoiceDialog from "components/Invoices/CloneInvoiceDialog";

import { DndContext, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import dayjs from "dayjs";
import { CKEditor } from "ckeditor4-react";
import axios from "axios";
import { DocumentPicker } from "components";
import { useSelector } from "react-redux";
import { dateFormat } from "constants/constants";
import SendInvoiceDrawer from "./SendInvoiceDrawer";
import { useNotification } from "NotificationContext";
import { compactToolbar } from "utilities/config";
import { nextLineKey, serializeLines, withLineKeys } from "utilities/quoteLines";
import InvoiceLineForm from "./InvoiceLineForm";
import InvoiceServiceForm from "./InvoiceServiceForm";
import ImportInvoiceLinesModal from "./ImportInvoiceLinesModal";
import { exportInvoiceLines } from "api/api";
import ScheduleReminderModal from "./ScheduleReminderModal";
import QuickAddAccountModal from "./QuickAddAccountModal";
import PreviewDrawerActions from "components/Common/PreviewDrawerActions";
import PdfViewer from "components/Common/PdfViewer";
import ExchangeRateInput from "components/Common/ExchangeRateInput";
import { formatMoney, recordCurrency, roundPayable } from "utils/money";
import {
  DISCOUNT_TYPE_OPTIONS,
  discountAmountOf,
  formatDiscount,
} from "utilities/discount";

const { Dragger } = Upload;

const InvoiceForm = () => {
  const notify = useNotification();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const paymentIdParam = searchParams.get('payment_id');
  const accountIdParam = searchParams.get('account_id');
  // "Generate Invoice" from a payment: the payment is fetched and its details
  // seed the new invoice. Applied once, after the option lists it depends on
  // (accounts, payment terms, currencies) have loaded.
  const [paymentPrefill, setPaymentPrefill] = useState(null);
  const paymentPrefillApplied = useRef(false);
  // Set once the user edits the invoice number by hand, so a later invoice-date
  // change does not overwrite their number with a generated one.
  const invNumberEdited = useRef(false);
  // Which option lists have finished loading. Tracked separately from the lists
  // themselves so an empty master table reads as "loaded", not "still waiting".
  const [prefillDepsLoaded, setPrefillDepsLoaded] = useState({
    accounts: false,
    paymentTerms: false,
    currencies: false,
  });
  const markPrefillDepLoaded = (key) =>
    setPrefillDepsLoaded((prev) => (prev[key] ? prev : { ...prev, [key]: true }));
  const [unlinkedPayments, setUnlinkedPayments] = useState([]);
  const [linkingPaymentId, setLinkingPaymentId] = useState(null);
  const [dataSource, setDataSource] = useState(null);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [accounts, setAccounts] = useState([]);
  const [quotes, setQuotes] = useState([]);
  const [taxRates, setTaxRates] = useState([]);
  const [, setProductCount] = useState(0);
  const [isManual, setIsManual] = useState(false);
  // const [products, setProducts] = useState([]);
  // const [services, setServices] = useState([]);
  const [net, setNet] = useState(0);
  // const [subtotal, setSubTotal] = useState([]);
  const [roundValue, setRoundValue] = useState(0);
  const [unRoundedTotal, setUnRoundedTotal] = useState(0);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [total, setTotal] = useState(0);
  const [totalTaxes, setTotalTaxes] = useState({});
  const [taxRate1, setTaxRate1] = useState(null);
  const [taxRate2, setTaxRate2] = useState(null);
  const [taxRate3, setTaxRate3] = useState(null);

  const [documents, setDocuments] = useState([]);
  const [attachments, setAttachments] = useState([]);

  const [invoiceStatuses, setInvoiceStatuses] = useState([]);

  const [previewPdfVisible, setPreviewPdfVisible] = useState(false);
  const [pdfPreviewData, setPdfPreviewData] = useState(null);
  const [numPages, setNumPages] = useState(0);

  const [paymentTerms, setPaymentTerms] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  // Teson products (SignVerse, PhotoStore, …) — an invoice may be tagged with
  // one, or with none. Distinct from the line-item products below.
  const [tesonProducts, setTesonProducts] = useState([]);
  // const [invoiceDate, setInvoiceDate] = useState(null);
  const [mainForm] = Form.useForm();
  const discountType = Form.useWatch("discount_type", mainForm);
  const selectedCurrencyId = Form.useWatch("currency", mainForm);
  const discountValue = Form.useWatch("discount_value", mainForm);

  // const [form] = Form.useForm();
  const [productForm] = Form.useForm();
  const [openInvoiceItemForm, setOpenInvoiceItemForm] = useState(false);
  const [currentProductInstance, setCurrentProductInstance] = useState(null);
  const [serviceForm] = Form.useForm();
  const [openServiceForm, setOpenServiceForm] = useState(false);
  const [currentServiceInstance, setCurrentServiceInstance] = useState(null);

  const [invoiceItemData, setInvoiceItemData] = useState([]);
  const [serviceData, setServiceData] = useState([]);
  const [totalHours, setTotalHours] = useState(0);
  const [totalDays, setTotalDays] = useState(0);
  const [openSendDrawer, setOpenSendDrawer] = useState(false);
  const [openViewDrawer, setOpenViewDrawer] = useState(false);
  const organization = useSelector((state) => state.auth.organization);

  const [editingKey, setEditingKey] = useState("");

  const [bankAccounts, setBankAccounts] = useState([]);
  const [selectedCurrencyIso, setSelectedCurrencyIso] = useState(null);
  const [pdfUrl, setPdfUrl] = useState("");
  const [pdfLoading, setPdfLoading] = useState(false);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [cloneDialogVisible, setCloneDialogVisible] = useState(false);
  const [importModalOpen, setImportModalOpen] = useState(false);
  const [exporting, setExporting] = useState(false);
  // Whether the current isManual value arrived from the server rather than the
  // user flipping the toggle.
  const loadedIsManualRef = useRef(null);

  // Schedule Reminder state
  const [scheduleReminderModalOpen, setScheduleReminderModalOpen] = useState(false);
  const [scheduledReminders, setScheduledReminders] = useState([]);
  const [reminderContacts, setReminderContacts] = useState({
    emails: [],
    emailCC: [],
    whatsappNumbers: [],
    phoneNumbers: [],
  });

  // Due date lock state - prevents auto-recalculation after first selection
  const [dueDateLocked, setDueDateLocked] = useState(false);

  // Customer fields state
  const [states, setStates] = useState([]);
  const [countries, setCountries] = useState([]);
  const [, setSelectedAccount] = useState(null);
  const [isAccountSelected, setIsAccountSelected] = useState(false);
  const [quickAddAccountOpen, setQuickAddAccountOpen] = useState(false);

  const isEditing = (record) => record.key === editingKey;

  const events = {
    onDocumentLoadSuccess: ({ numPages }) => {
      setNumPages(numPages);
    },
  };

  // Handle payment term change
  const handlePaymentTermChange = (value) => {
    // Only calculate due date if it hasn't been locked yet
    if (!dueDateLocked) {
      const invoiceDate = mainForm.getFieldValue("invoice_date");
      if (invoiceDate && value) {
        const term = paymentTerms.find((term) => term.id === value);
        const newDueDate = dayjs(invoiceDate).add(term.duration_in_days, "day");
        mainForm.setFieldsValue({ due_date: newDueDate });
        // Lock the due date after first calculation
        setDueDateLocked(true);
      }
    }
  };

  // Handle invoice date change
  const handleInvoiceDateChange = (date) => {
    // The invoice number is scoped to the month of the invoice date, so moving
    // the date to another month re-mints it as that month's next number. Only
    // for new invoices, and never over a number the user typed themselves.
    if (!id && !invNumberEdited.current) {
      const current = mainForm.getFieldValue("inv_number");
      const currentMonth = typeof current === "string" ? current.slice(0, 12) : "";
      const targetMonth = date && dayjs(date).isValid()
        ? `TSNIT${dayjs(date).format("YYYY")}${dayjs(date).format("MMM").toUpperCase()}`
        : "";
      if (targetMonth && currentMonth !== targetMonth) {
        loadGeneratedInvoiceNumber(date);
      }
    }

    // Only auto-calculate due date if it hasn't been locked yet
    if (!dueDateLocked) {
      const selectedPaymentTerm = mainForm.getFieldValue("payment_term");
      const term = paymentTerms.find((term) => term.id === selectedPaymentTerm);
      if (date && term) {
        const newDueDate = dayjs(date).add(term.duration_in_days, "day");
        mainForm.setFieldsValue({ due_date: newDueDate });
        // Lock the due date after first calculation
        setDueDateLocked(true);
      }
    }
  };

  const onFinish = (values) => {
    console.log("Success:", values);

    // Saved lines keep their id so the backend updates them in place; anything
    // else is a new line. The backend renumbers priority from the order of the
    // combined list, which is what keeps products and services from clashing.
    const modifiedProductData = serializeLines(
      Array.isArray(invoiceItemData) ? invoiceItemData : []
    );
    const modifiedServiceData = serializeLines(
      Array.isArray(serviceData) ? serviceData : []
    );

    if (values) {
      // Use environment variable as primary source, fallback to Redux state
      const orgId = process.env.REACT_APP_ORGANIZATION_UUID || organization;

      // onSaveHandler({ ...values, organization: organization, invoice_date: values?.invoice_date.format(dateFormat), due_date: values?.due_date.format(dateFormat), invoiceitem_set: invoiceItemData, invoiceservice_set: serviceData, net: net, total: total })
      onSaveHandler({
        ...values,
        organization: orgId,
        invoice_date: values?.invoice_date.format(dateFormat),
        due_date: values?.due_date.format(dateFormat),
        invoiceitem_set: [...modifiedProductData, ...modifiedServiceData],
        net: net,
        total: total,
        is_manual: values?.is_manual ? values?.is_manual : false,
        is_authorized_signature_required: values?.is_authorized_signature_required ? values?.is_authorized_signature_required : false,
        show_bank_details: values?.show_bank_details ? values?.show_bank_details : false,
        is_computer_generated: values?.is_computer_generated !== undefined ? values?.is_computer_generated : true
      });
    }
  };

  const loadInvoice = async () => {
    if (id) {
      const response = await adminactions.loadInvoice(id);
      console.log("Invoice Response:", response);
      console.log("Invoice Date Raw:", response?.invoice_date);
      console.log("Due Date Raw:", response?.due_date);

      if (response) {
        console.log("Changing state now...");

        // Parse dates properly - backend sends YYYY-MM-DD format
        const invoiceDate = response.invoice_date
          ? dayjs(response.invoice_date, "YYYY-MM-DD")
          : null;
        const dueDate = response.due_date
          ? dayjs(response.due_date, "YYYY-MM-DD")
          : null;

        // Validate parsed dates
        if (invoiceDate && !invoiceDate.isValid()) {
          console.error("Invalid invoice date:", response.invoice_date);
        }
        if (dueDate && !dueDate.isValid()) {
          console.error("Invalid due date:", response.due_date);
        }

        console.log("Parsed Invoice Date:", invoiceDate?.isValid() ? invoiceDate.format("YYYY-MM-DD") : "INVALID");
        console.log("Parsed Due Date:", dueDate?.isValid() ? dueDate.format("YYYY-MM-DD") : "INVALID");

        // Create clean data object with properly parsed dates
        const cleanData = {
          ...response,
          invoice_date: invoiceDate && invoiceDate.isValid() ? invoiceDate : null,
          due_date: dueDate && dueDate.isValid() ? dueDate : null
        };

        setDataSource(cleanData);

        // Lock due date for existing invoices since they already have a calculated due date
        if (cleanData.due_date) {
          setDueDateLocked(true);
        }

        // Lines arrive in priority order; keys and priorities are renumbered
        // from that order so both are dense and unique.
        const sortedItems = [...(response.invoiceitem_set || [])].sort(
          (a, b) => (a.priority || 0) - (b.priority || 0)
        );
        setInvoiceItemData(withLineKeys(sortedItems));
        setServiceData(withLineKeys(response.invoiceservice_set || []));
        setDocuments(response.documents);
        setAttachments(response.attachments);
        // Remember that this value came from the server, not from the user
        // flipping the toggle — see the effect that clears the lines.
        loadedIsManualRef.current = response.is_manual;
        setIsManual(response.is_manual);
        setNet(response.net);
        setTotal(response.total);
        setTaxRate1(response.tax_rate1_data);
        setTaxRate2(response.tax_rate2_data);
        setTaxRate3(response.tax_rate3_data);

        // Set selected currency ISO code
        if (response.currency_data?.iso_code) {
          setSelectedCurrencyIso(response.currency_data.iso_code);
        }

        // Set account selection state
        if (response.account) {
          setIsAccountSelected(true);
        }

        // Load bank accounts for the invoice's organization
        if (response.organization) {
          loadBankAccounts(response.organization);
        }
      }
    }
    setLoading(false);
  };

  const loadAccounts = async () => {
    try {
      const response = await adminactions.loadAccounts(1, undefined, 1000);
      // console.log(response)
      if (response.status === 200) {
        setAccounts(response.data.results);
      }
    } finally {
      markPrefillDepLoaded("accounts");
    }
  };

  const loadQuotes = async (accountId = null) => {
    try {
      const response = await axios.get('/quotes/quotes/', {
        params: accountId ? { account: accountId } : {}
      });
      if (response.status === 200) {
        setQuotes(response.data.results || response.data);
      }
    } catch (e) {
      console.log("Error loading quotes:", e);
    }
  };

  const loadPaymentTerms = async () => {
    try {
      const response = await axios.get("/masters/payment-terms/");
      if (response.status === 200) {
        setPaymentTerms(response.data);
      }
    } finally {
      markPrefillDepLoaded("paymentTerms");
    }
  };

  const loadCurrencies = async () => {
    try {
      const response = await axios.get("/masters/currencies/");
      if (response.status === 200) {
        setCurrencies(response.data);
      }
    } finally {
      markPrefillDepLoaded("currencies");
    }
  };

  const loadTesonProducts = async () => {
    try {
      const response = await adminactions.loadPaymentProducts();
      if (response.status === 200) {
        setTesonProducts(response.data.results || response.data || []);
      }
    } catch (e) {
      console.error("Error loading products:", e);
    }
  };

  const loadInvoiceStatuses = async () => {
    const response = await adminactions.loadInvoiceStatuses();
    if (response) {
      setInvoiceStatuses(response);
    }
  };

  const loadBankAccounts = async (orgId) => {
    // Use .env organization ID as the primary source for bank accounts
    // This ensures bank accounts are always fetched for the configured organization
    const envOrgId = process.env.REACT_APP_ORGANIZATION_UUID;
    const organizationId = envOrgId || orgId || organization;

    if (!organizationId) {
      console.error("❌ No organization ID available to load bank accounts");
      console.error("   - .env REACT_APP_ORGANIZATION_UUID:", envOrgId);
      console.error("   - orgId parameter:", orgId);
      console.error("   - Redux organization:", organization);
      console.error("   ⚠️  Please set REACT_APP_ORGANIZATION_UUID in .env file");
      return;
    }

    console.log("✅ Loading bank accounts for organization:", organizationId);
    try {
      const response = await adminactions.loadBankAccounts(organizationId);
      if (response && Array.isArray(response)) {
        console.log("✅ Bank accounts loaded:", response.length, "accounts");
        setBankAccounts(response);
        // Set first bank account as default for new invoices
        if (!id && response.length > 0 && !mainForm.getFieldValue("org_bank_account")) {
          mainForm.setFieldValue("org_bank_account", response[0].id);
        }
      } else {
        console.error("❌ Failed to load bank accounts - invalid response");
      }
    } catch (error) {
      console.error("❌ Error loading bank accounts:", error);
    }
  };

  // const loadProducts = async () => {
  //     const response = await adminactions.loadProducts();
  //     if (response) {
  //         setProducts(response.data.results);
  //     }
  // }

  // const loadServices = async () => {
  //     const response = await adminactions.loadServices();
  //     if (response) {
  //         setServices(response.data.results);
  //     }
  // }

  const loadUnlinkedPaymentsForAccount = async (accountId) => {
    if (!accountId || !id) return; // Only for existing invoices
    const payments = await adminactions.loadUnlinkedPayments(accountId);
    setUnlinkedPayments(payments || []);
  };

  const handleLinkPayment = async (paymentId) => {
    if (!id) return;
    setLinkingPaymentId(paymentId);
    try {
      await adminactions.linkPaymentToInvoice(paymentId, id);
      message.success("Payment linked successfully!");
      // Refresh invoice and unlinked payments
      loadInvoice();
      const accountId = mainForm.getFieldValue('account');
      if (accountId) loadUnlinkedPaymentsForAccount(accountId);
    } catch (err) {
      message.error("Failed to link payment");
    } finally {
      setLinkingPaymentId(null);
    }
  };

  const loadTaxRates = async () => {
    const response = await adminactions.loadTaxRates();
    if (response) {
      setTaxRates(response);
    }
  };

  const loadPaymentForPrefill = async (paymentId) => {
    try {
      const payment = await adminactions.loadPayment(paymentId);
      if (payment) setPaymentPrefill(payment);
    } catch (e) {
      console.error("Error loading payment for invoice prefill:", e);
    }
  };

  // Fetches the next number for the month of `date` (the invoice date currently
  // on the form when not given), so number and invoice date always share a month.
  const loadGeneratedInvoiceNumber = async (date) => {
    // Use .env organization ID as the primary source
    const envOrgId = process.env.REACT_APP_ORGANIZATION_UUID;
    const orgId = envOrgId || organization;

    if (orgId) {
      const forDate = date || mainForm.getFieldValue("invoice_date");
      const formattedDate = forDate && dayjs(forDate).isValid()
        ? dayjs(forDate).format("YYYY-MM-DD")
        : undefined;
      const response = await adminactions.generateInvoiceNumber(orgId, formattedDate);
      if (response && response.invoice_number) {
        mainForm.setFieldValue("inv_number", response.invoice_number);
        invNumberEdited.current = false;
      }
    }
  };

  const onSaveHandler = async (values) => {
    console.log("VALUES", values);
    setSubmitting(true);
    try {
      if (id) {
        //to replace undefined with nulls, so that new data is stored
        let keys = Object.keys(values);
        keys.forEach((k, i) => {
          if (!values[k] && values[k] !== false) {
            values[k] = null;
          }
        });

        const response = await adminactions.updateInvoices(values, id);
        if (response?.status === 200) {
          // navigate("/invoices")
          // alert("Invoice updated successfully");
          message.success("Invoice updated successfully!");
          setHasUnsavedChanges(false);
          // Re-read the saved lines so the form holds the ids the backend just
          // assigned; without that the next save treats new lines as new again.
          await loadInvoice();
        } else {
          message.error("Failed to update invoice. Please check the form and try again.");
        }
      } else {
        const response = await adminactions.addInvoices(values);
        if (response) {
          setHasUnsavedChanges(false);
          // Auto-link payment if created from payment flow
          if (paymentIdParam) {
            try {
              await adminactions.linkPaymentToInvoice(paymentIdParam, response.id);
              message.success("Invoice created and payment linked successfully!");
            } catch (linkErr) {
              console.error("Error linking payment:", linkErr);
              message.warning("Invoice created but failed to link payment.");
            }
          }
          navigate("/invoices/edit/" + response.id);
        }
      }
    } finally {
      setSubmitting(false);
    }
  };

  const getTaxes = (object) => {
    const string = [];
    for (const [key, value] of object) {
      string.push({ key: key, value: value });
    }
    return string;
  };

  const loadStatesData = async () => {
    try {
      const response = await dispatch(loadStates());
      if (response.payload) {
        setStates(response.payload);
      }
    } catch (err) {
      console.error("Error loading states:", err);
    }
  };

  const loadCountriesData = async () => {
    try {
      const response = await dispatch(loadCountries());
      if (response.payload) {
        setCountries(response.payload);
      }
    } catch (err) {
      console.error("Error loading countries:", err);
    }
  };

  const onAccountChange = (value) => {
    console.log(`selected ${value}`);

    if (value) {
      // Find the selected account
      const account = accounts.find(acc => acc.id === value);
      setSelectedAccount(account);
      setIsAccountSelected(true);

      // Auto-populate customer fields from account
      if (account) {
        mainForm.setFieldsValue({
          legal_name_of_business: account.legal_name_of_business,
          gst_number: account.gst_number,
          place_of_supply: account.place_of_supply,
          billing_address1: account.billing_address1,
          billing_address2: account.billing_address2,
          billing_city: account.billing_city,
          billing_state: account.billing_state,
          billing_postal_code: account.billing_postal_code,
          billing_country: account.billing_country,
          billing_phone: account.billing_phone,
          shipping_address1: account.shipping_address1,
          shipping_address2: account.shipping_address2,
          shipping_city: account.shipping_city,
          shipping_state: account.shipping_state,
          shipping_postal_code: account.shipping_postal_code,
          shipping_country: account.shipping_country,
          shipping_phone: account.shipping_phone,
        });
      }
    } else {
      // Account was cleared
      setSelectedAccount(null);
      setIsAccountSelected(false);
    }
  };

  const onQuickAccountCreated = (account) => {
    if (!account?.id) return;
    // Add the newly created account to the list and select it.
    setAccounts((prev) => {
      const exists = prev.some((acc) => acc.id === account.id);
      return exists ? prev : [account, ...prev];
    });
    setSelectedAccount(account);
    setIsAccountSelected(true);
    mainForm.setFieldValue("account", account.id);
    mainForm.setFieldsValue({
      legal_name_of_business: account.legal_name_of_business,
      gst_number: account.gst_number,
      place_of_supply: account.place_of_supply,
      billing_address1: account.billing_address1,
      billing_address2: account.billing_address2,
      billing_city: account.billing_city,
      billing_state: account.billing_state,
      billing_postal_code: account.billing_postal_code,
      billing_country: account.billing_country,
      billing_phone: account.billing_phone,
      shipping_address1: account.shipping_address1,
      shipping_address2: account.shipping_address2,
      shipping_city: account.shipping_city,
      shipping_state: account.shipping_state,
      shipping_postal_code: account.shipping_postal_code,
      shipping_country: account.shipping_country,
      shipping_phone: account.shipping_phone,
    });
    // Filter quotes by the new account and clear any prior quote selection.
    loadQuotes(account.id);
    mainForm.setFieldValue("quote", null);
    setQuickAddAccountOpen(false);
  };

  const onAccountSearch = (value) => {
    console.log("search:", value);
  };

  const previewDownloadPdf = async (preview, download) => {
    const response = await adminactions.downloadInvoice(
      id,
      true,
      "INVOICE_TEMPLATE_1"
    );
    console.log({ response });
    if (response) {
      if (download) {
        const filename = dataSource?.inv_number ? `${dataSource.inv_number}.pdf` : "invoice.pdf";
        fileDownload(response, filename);
      }
      if (preview) {
        setPdfPreviewData(response);
        setPreviewPdfVisible(true);
      }
    }
  };

  const handleCloneSuccess = (clonedInvoices) => {
    // Close the dialog
    setCloneDialogVisible(false);

    // Show success message
    message.success(`Successfully cloned ${clonedInvoices.length} invoice(s)`);

    // Redirect to the first cloned invoice or refresh the list
    if (clonedInvoices.length === 1) {
      window.location.href = `/invoices/edit/${clonedInvoices[0].id}`;
    } else {
      // If multiple invoices were cloned, navigate to invoice list
      window.location.href = '/invoices';
    }
  };

  // const editProduct = (record) => {
  //     form.setFieldsValue({
  //         name: record.name,
  //         description: record.description,
  //         quantity: record.quantity,
  //         price: record.price,
  //         line_total: record.line_total,
  //         tax_rate1: record.tax_rate1,
  //         tax_rate2: record.tax_rate2,
  //         tax_rate3: record.tax_rate3,
  //         ...record,
  //     });
  //     setEditingKey(record.key);
  // };

  const deleteRecord = (recordkey, type) => {
    switch (type) {
      case "product":
        const newProductData = [...invoiceItemData];
        const productIndex = newProductData.findIndex(
          (item) => recordkey === item.key
        );
        newProductData.splice(productIndex, 1);
        setInvoiceItemData(newProductData);
        break;
      case "service":
        const newServiceData = [...serviceData];
        const serviceIndex = newServiceData.findIndex(
          (item) => recordkey === item.key
        );
        newServiceData.splice(serviceIndex, 1);
        setServiceData(newServiceData);
        break;
      default:
        console.error("Error occurred");
    }
  };

  const cloneLineItem = (record, type) => {
    // A clone is a new line: it gets a fresh row key and no database id, so it
    // is inserted rather than overwriting the line it was copied from. A
    // timestamp is not unique enough — two clones can land in the same
    // millisecond and then edits hit both rows.
    const insertClone = (prev) => {
      const clonedItem = { ...record, key: nextLineKey(prev), id: undefined };
      const index = prev.findIndex((item) => item.key === record.key);
      const newData = [...prev];
      newData.splice(index + 1, 0, clonedItem);
      return newData;
    };

    if (type === "product") {
      setInvoiceItemData(insertClone);
    } else if (type === "service") {
      setServiceData(insertClone);
    }
    setHasUnsavedChanges(true);
  };

  const cancel = () => {
    isEditing(false);
    // form.current = null;
    setEditingKey("");
  };

  const onChange = (key) => {
    console.log(key);
    cancel();
  };

  const handleAddDocument = async (doc_ids = []) => {
    const response = await adminactions.addDocumentsToInvoice(id, doc_ids);
    if (response) {
      setDocuments(response);
    }
  };

  const handleDeleteDocument = async (doc_id) => {
    const response = await adminactions.removeDocumentFromInvoice(id, doc_id);
    if (response) {
      setDocuments(response);
    }
  };

  const handleDeleteAttachment = async (doc_id) => {
    const response = await adminactions.removeDocumentFromInvoice(id, doc_id);
    if (response) {
      setAttachments(response);
    }
  };

  // Handle importing invoice lines from Excel.
  // "replace" makes the file the whole list, so a row deleted in Excel removes
  // that line. "append" keeps the existing lines and adds to them. Either way a
  // row carrying an id updates that line in place instead of duplicating it.
  const handleImportInvoiceLines = (items, mode = "append") => {
    const existing = mode === "replace" ? [] : [...invoiceItemData];
    const byId = new Map(
      invoiceItemData.filter((line) => line.id).map((line) => [line.id, line])
    );

    let key = nextLineKey(invoiceItemData);
    let updatedCount = 0;
    let addedCount = 0;
    const merged = existing;

    items.forEach((item) => {
      const previous = item.id ? byId.get(item.id) : undefined;
      const existingIndex = previous
        ? merged.findIndex((line) => line.id === item.id)
        : -1;

      if (previous) {
        const updated = {
          ...previous,
          ...item,
          key: previous.key,
          id: previous.id,
          invoice: id,
        };
        if (existingIndex !== -1) {
          merged[existingIndex] = updated;
        } else {
          merged.push(updated);
        }
        updatedCount += 1;
      } else {
        // Dropping the id here matters: an id we do not recognise would make
        // the backend reject the save rather than add the line.
        const { id: importedId, ...rest } = item;
        merged.push({ ...rest, key: key++, invoice: id });
        addedCount += 1;
      }
    });

    const removedCount =
      mode === "replace"
        ? invoiceItemData.filter(
            (line) => !merged.some((kept) => kept.key === line.key)
          ).length
        : 0;

    updateInvoiceItemData(merged.map((line, index) => ({ ...line, priority: index + 1 })));
    setImportModalOpen(false);

    const parts = [];
    if (addedCount) parts.push(`${addedCount} added`);
    if (updatedCount) parts.push(`${updatedCount} updated`);
    if (removedCount) parts.push(`${removedCount} removed`);
    message.success(
      `${items.length} invoice line(s) imported` +
        (parts.length ? ` (${parts.join(", ")})` : "")
    );
  };

  // Export this invoice's lines so they can be edited in Excel and imported back.
  const handleExportInvoiceLines = async () => {
    setExporting(true);
    try {
      await exportInvoiceLines(id);
    } catch (err) {
      console.error("Failed to export invoice lines:", err);
    } finally {
      setExporting(false);
    }
  };

  const props = {
    name: "file",
    multiple: false,
    action: process.env.REACT_APP_BASE_URL + `/invoices/invoices/${id}/addDoc/`,
    headers: { Authorization: axios.defaults.headers.common["Authorization"] },
    onChange(info) {
      console.log(info);
      const { status, response } = info.file;
      if (status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (status === "done") {
        message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }

      if (response) {
        setAttachments(response);
      }
    },
    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
    },
  };

  const viewDownloadDocument = async (record, preview, download) => {
    const doc = getDocument(record);
    if (!getDocumentFileUrl(record)) {
      notify("error", "This document has no file attached");
      return;
    }
    if (download) {
      const done = await downloadDocumentFile(record);
      if (!done) {
        notify("error", "Allow pop-ups for this site to download the file");
      }
    }
    if (preview) {
      if (doc?.extension === ".pdf") {
        setPdfPreviewData(await getDocumentPreviewSource(record));
        setPreviewPdfVisible(true);
      } else {
        notify("error", "only pdfs can be rendered for now");
      }
    }
  };

  const productColumns = [
    {
      title: "Item",
      dataIndex: "title",
      width: "10%",
      // editable: true,
    },
    {
      title: "Description",
      dataIndex: "description",
      width: "20%",
      // editable: true,
      render: (text, record, index) => {
        return <div dangerouslySetInnerHTML={{ __html: record.description }} />;
      },
    },
    {
      title: "HSN/SAC",
      dataIndex: "hsn",
      width: "8%",
      // editable: true,
    },
    {
      title: "Unit",
      dataIndex: "unit",
      width: "8%",
      // editable: true,
    },
    {
      title: "Price/unit",
      dataIndex: "price",
      width: "8%",
      align: "right",
      // editable: true,
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      width: "8%",
      align: "right",
      // editable: true,
      render: (text, record, index) => {
        if (record?.is_fixed_rate) {
          return <div>FIXED RATE</div>;
        } else {
          return record?.quantity;
        }
      },
    },
    {
      title: "Tax Rate",
      dataIndex: "tax_rate1",
      width: "6%",
      align: "right",
      // editable: true,
      render: (text, record, index) => {
        const taxRate = taxRates.find((item) => item.id === text);
        if (taxRate) {
          return `${taxRate?.title + " " + taxRate?.rate} %`;
        }
        return null;
      },
    },
    {
      title: "Tax Rate",
      dataIndex: "tax_rate2",
      width: "6%",
      align: "right",
      // editable: true,
      render: (text, record, index) => {
        const taxRate = taxRates.find((item) => item.id === text);
        if (taxRate) {
          return `${taxRate?.title + " " + taxRate?.rate} %`;
        }
        return null;
      },
    },
    {
      title: "Tax Rate",
      dataIndex: "tax_rate3",
      width: "6%",
      align: "right",
      // editable: true,
      render: (text, record, index) => {
        const taxRate = taxRates.find((item) => item.id === text);
        if (taxRate) {
          return `${taxRate?.title + " " + taxRate?.rate} %`;
        }
        return null;
      },
    },
    {
      title: "Discount",
      dataIndex: "discount_value",
      width: "7%",
      align: "right",
      render: (_, record) => formatDiscount(record.discount_type, record.discount_value),
    },
    {
      title: "Line Total",
      dataIndex: "line_total",
      width: "10%",
      align: "right",
      // editable: true,
      // render: (text, record, index) => {
      //     return <div>{record.price * record.quantity}</div>
      // }
    },
    {
      title: "Actions",
      dataIndex: "action",
      width: "8%",
      render: (_, record) => {
        return (
          <Space size="middle">
            <Typography.Link
              onClick={() => {
                setCurrentProductInstance(record);
                setOpenInvoiceItemForm(true);
              }}
              title="Edit"
            >
              <EditOutlined />
            </Typography.Link>
            <Typography.Link
              onClick={() => cloneLineItem(record, "product")}
              title="Clone"
            >
              <CopyOutlined />
            </Typography.Link>
            <Popconfirm
              title="Sure to delete?"
              onConfirm={() => deleteRecord(record.key, "product")}
            >
              <Typography.Link title="Delete">
                <DeleteOutlined style={{ color: '#ff4d4f' }} />
              </Typography.Link>
            </Popconfirm>
          </Space>
        );
      },
    },
  ];


  const documentColumns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      sorter: (a, b) => a?.id.localeCompare(b?.id),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a?.name.localeCompare(b?.name),
    },
    {
      title: "Date",
      dataIndex: "created_at",
      key: "created_at",
      sorter: (a, b) => dayjs(a?.created_at) - dayjs(b?.created_at),
      render: (text, record) => {
        return <div>{dayjs(text).format("MMMM Do YYYY, h:mm:ss a")}</div>;
      },
    },
    {
      title: "Size",
      dataIndex: "size",
      key: "size",
      sorter: (a, b) => a?.org_size - b?.org_size,
    },
    {
      title: "Linked",
      dataIndex: "is_linked",
      key: "is_linked",
      sorter: (a, b) => a?.is_linked - b?.is_linked,
      render: (_, record) => {
        const size = 8;
        const radius = "30%";
        return (
          <div className="d-flex justify-content-center align-items-center">
            {record.is_linked ? (
              <>
                <div
                  style={{
                    width: size,
                    height: size,
                    backgroundColor: "green",
                    borderRadius: radius,
                  }}
                ></div>
              </>
            ) : (
              <>
                <div
                  style={{
                    width: size,
                    height: size,
                    backgroundColor: "red",
                    borderRadius: radius,
                  }}
                ></div>
              </>
            )}
          </div>
        );
      },
    },
    {
      title: "Actions",
      dataIndex: "action",
      render: (_, record) => {
        return (
          <span>
            <Typography.Link
              onClick={() => {
                console.log("View Document");
                viewDownloadDocument(record, true, false);
              }}
            >
              View
            </Typography.Link>
            <Typography.Link
              className="ms-2"
              onClick={() => {
                console.log("Download Document");
                viewDownloadDocument(record, false, true);
              }}
            >
              Download
            </Typography.Link>
            <Popconfirm
              title="Sure to delete?"
              onConfirm={() => handleDeleteDocument(record.id)}
            >
              <a style={{ marginLeft: 10 }}>Delete</a>
            </Popconfirm>
          </span>
        );
      },
    },
  ];

  const attachmentColumns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      sorter: (a, b) => a?.id.localeCompare(b?.id),
    },
    {
      title: "Name",
      dataIndex: ["document", "name"],
      key: "name",
      sorter: (a, b) => a?.name.localeCompare(b?.name),
    },
    {
      title: "Date",
      dataIndex: "created_at",
      key: "created_at",
      sorter: (a, b) => dayjs(a?.created_at) - dayjs(b?.created_at),
      render: (text, record) => {
        return <div>{dayjs(text).format("MMMM Do YYYY, h:mm:ss a")}</div>;
      },
    },
    {
      title: "Size",
      dataIndex: ["document", "size"],
      key: "size",
      sorter: (a, b) => a?.org_size - b?.org_size,
    },
    {
      title: "Linked",
      dataIndex: ["document", "is_linked"],
      key: "is_linked",
      sorter: (a, b) => a?.is_linked - b?.is_linked,
      render: (_, record) => {
        const size = 8;
        const radius = "30%";
        return (
          <div className="d-flex justify-content-center align-items-center">
            {record.is_linked ? (
              <>
                <div
                  style={{
                    width: size,
                    height: size,
                    backgroundColor: "green",
                    borderRadius: radius,
                  }}
                ></div>
              </>
            ) : (
              <>
                <div
                  style={{
                    width: size,
                    height: size,
                    backgroundColor: "red",
                    borderRadius: radius,
                  }}
                ></div>
              </>
            )}
          </div>
        );
      },
    },
    {
      title: "Actions",
      dataIndex: "action",
      render: (_, record) => {
        return (
          <Flex gap="middle">
            <Typography.Link
              onClick={() => {
                console.log("View Document");
                viewDownloadDocument(record, true, false);
              }}
            >
              <EyeOutlined />
            </Typography.Link>
            <Typography.Link
              onClick={() => {
                console.log("Download Document");
                viewDownloadDocument(record, false, true);
              }}
            >
              <DownloadOutlined />
            </Typography.Link>
            <Popconfirm
              title="Sure to delete?"
              onConfirm={() => handleDeleteAttachment(record.id)}
            >
              <DeleteOutlined />
            </Popconfirm>
          </Flex>
        );
      },
    },
  ];

  const TableRow = (props) => {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
      id: props['data-row-key'],
    });
    const style = {
      ...props.style,
      transform: transform ? CSS.Translate.toString(transform) : undefined,
      transition,
      cursor: 'move',
      ...(isDragging
        ? {
          position: 'relative',
          zIndex: 1000,
        }
        : {}),
    };
    return <tr {...props} ref={setNodeRef} style={style} {...attributes} {...listeners} />;
  };

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        // https://docs.dndkit.com/api-documentation/sensors/pointer#activation-constraints
        distance: 1,
      },
    }),
  );
  const onDragEnd = ({ active, over }) => {
    if (active.id !== over?.id) {
      setInvoiceItemData((prev) => {
        const activeIndex = prev.findIndex((i) => i.key === active.id);
        const overIndex = prev.findIndex((i) => i.key === over?.id);
        const newArray = arrayMove(prev, activeIndex, overIndex);
        
        // Assign new priority values based on the new order
        return newArray.map((item, index) => ({
          ...item,
          priority: index + 1
        }));
      });
      
      // Mark as having unsaved changes when items are reordered
      setHasUnsavedChanges(true);
    }
  };

  const mergedColumns = productColumns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: ["price", "quantity", "line_total"].includes(col.dataIndex)
          ? "number"
          : "text",
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });

  const editorConfig = {
    extraPlugins: ["tableresize", "uploadimage", "createpdf"],
    removePlugins: [
      "exportpdf",
      "forms",
      "smiley",
      "language",
      "iframe",
      "about",
    ],
    // filebrowserBrowseUrl: 'http://localhost:4000/media/24b358cf-8e56-4b03-9843-29fabf589b8d/template/home-advt_jzx7KBU.jpeg',
    filebrowserImageUploadUrl:
      process.env.REACT_APP_BASE_URL + `/template/upload_template_image/`,
    fileTools_requestHeaders: axios.defaults.headers.common,
    uploadUrl:
      process.env.REACT_APP_BASE_URL + `/template/upload_template_image/`,
    contentsCss: [
      // "https://cdn.jsdelivr.net/npm/bootstrap@4.3.1/dist/css/bootstrap.min.css",
      process.env.REACT_APP_BASE_URL +
      "/staticfiles/ckeditor/4.19.0/full-all/document-style.css",
      "/ckeditor-content.css",
  ],
    bodyClass: "document-editor",
    // height: 900,
    // width: 1000,
    height: "5cm",
    // width: "18.6cm",
    width: "21cm",
    allowedContent: true,
    // extraPlugins: [
    //     'timestamp'
    // ]
    // exportPdf_options: {
    //     header_html: '<div class="styled">This is the Header</div>',
    //     footer_html: '<div class="styled-counter"><span class="date></span></div>',
    //     header_and_footer_css: '.styled { font-weight: bold; padding: 10px; display: flex; color: red; } .styled-counter {font-size: 10px; color: red; }',
    //     margin_top: '2cm',
    //     margin_bottom: '10cm',
    // }
    // exportPdf_options: {
    //     format: "A3"
    // }
    exportPdf_options: {
      header_html: '<div class="styled">Header content</div>',
      footer_html: '<div class="styled"><span class="pageNumber"></span></div>',
      header_and_footer_css:
        ".styled { font-weight: bold; padding: 10px; text-align: center; color: red; }",
      margin_left: "1cm",
      margin_right: "2cm",
      format: "A5",
      page_orientation: "landscape",
    },
    protectedSource: [/{%[\s\S]*?%}+/g, /{{[\s\S]*?}}+/g],
    // formatOutput: false,
    // formatSource: false,
    // Phones get a short toolbar; desktop keeps the full grouped one.
    ...compactToolbar(),
  };

  useEffect(() => {
    loadTaxRates();
    loadInvoice();
    loadAccounts();
    loadQuotes();
    loadPaymentTerms();
    loadCurrencies();
    loadStatesData();
    loadCountriesData();
    loadTesonProducts();
    // loadProducts();
    // loadServices();
    loadInvoiceStatuses();
    if (!id) {
      loadGeneratedInvoiceNumber();
      if (paymentIdParam) {
        // Details are taken from the payment itself (see the prefill effect below)
        loadPaymentForPrefill(paymentIdParam);
      } else if (accountIdParam) {
        // Pre-select account from query param (payment-first flow)
        setTimeout(() => {
          mainForm.setFieldsValue({ account: accountIdParam });
          onAccountChange(accountIdParam);
        }, 500);
      }
    }
    // Try to load bank accounts on mount
    loadBankAccounts();
  }, []);

  // Seed a new invoice from the payment it is being generated for.
  // Waits for accounts / payment terms / currencies so the Selects resolve to
  // real options instead of dangling ids, and runs only once.
  useEffect(() => {
    if (id || !paymentPrefill || paymentPrefillApplied.current) return;
    const { accounts: accountsLoaded, paymentTerms: termsLoaded, currencies: currenciesLoaded } = prefillDepsLoaded;
    if (!accountsLoaded || !termsLoaded || !currenciesLoaded) return;
    paymentPrefillApplied.current = true;

    const values = {};

    // Invoice date follows the payment date; due date matches it, since the
    // money is already in — nothing is actually outstanding.
    const paidOn = paymentPrefill.payment_date || paymentPrefill.created_at;
    if (paidOn) {
      values.invoice_date = dayjs(paidOn);
      values.due_date = dayjs(paidOn);
      // The number fetched on mount belongs to the current month; re-mint it for
      // the month the invoice is actually dated in (the payment's month).
      if (!invNumberEdited.current) {
        loadGeneratedInvoiceNumber(paidOn);
      }
    }

    // Payment term: "Due on Receipt". Matched by name, since the ids are
    // per-installation; falls back to the shortest term configured.
    const dueOnReceipt =
      paymentTerms.find((t) => /due\s*on\s*receipt/i.test(t.name || ""))
      || [...paymentTerms].sort((a, b) => (a.duration_in_days ?? 0) - (b.duration_in_days ?? 0))[0];
    if (dueOnReceipt) values.payment_term = dueOnReceipt.id;

    // The payment has been received, so the invoice is settled on creation.
    values.status = "PAID";

    // Carry over the product tag when the payment came through a payment link
    // that had one.
    if (paymentPrefill.payment_link_data?.product) {
      values.product = paymentPrefill.payment_link_data.product;
    }

    // Currency of the payment when it has one, INR otherwise.
    const inr = currencies.find((c) => c.iso_code === "INR");
    const paymentCurrency = paymentPrefill.currency
      ? currencies.find((c) => c.id === paymentPrefill.currency)
      : null;
    const currency = paymentCurrency || inr;
    if (currency) {
      values.currency = currency.id;
      setSelectedCurrencyIso(currency.iso_code);
      values.exchange_rate = currency.iso_code === "INR"
        ? 1.0
        : (paymentPrefill.exchange_rate ? parseFloat(paymentPrefill.exchange_rate) : undefined);
    }

    mainForm.setFieldsValue(values);

    // Customer information — from the account when the payment has one (this
    // fills legal name, GST, billing/shipping address), otherwise from the
    // payer details captured by the payment link.
    if (paymentPrefill.account) {
      mainForm.setFieldsValue({ account: paymentPrefill.account });
      onAccountChange(paymentPrefill.account);
      loadQuotes(paymentPrefill.account);
    } else {
      const customerName = paymentPrefill.customer_name || paymentPrefill.payer_details?.name;
      const customerPhone = paymentPrefill.customer_phone || paymentPrefill.payer_details?.phone;
      mainForm.setFieldsValue({
        ...(customerName ? { legal_name_of_business: customerName } : {}),
        ...(customerPhone ? { billing_phone: customerPhone, shipping_phone: customerPhone } : {}),
      });
    }

    setHasUnsavedChanges(true);
  }, [id, paymentPrefill, prefillDepsLoaded, accounts, paymentTerms, currencies]);

  // Load bank accounts when organization is available
  useEffect(() => {
    // Try to load bank accounts even if organization is not set yet
    // The loadBankAccounts function has fallback logic
    loadBankAccounts(organization);
  }, [organization]);

  // Load unlinked payments for linking (edit mode only)
  useEffect(() => {
    if (dataSource?.account && id) {
      loadUnlinkedPaymentsForAccount(dataSource.account);
    }
  }, [dataSource?.account, id]);

  // Update form fields when dataSource changes
  useEffect(() => {
    if (dataSource && !loading) {
      console.log("=== UPDATING FORM FIELDS ===");
      console.log("Invoice Date:", dataSource.invoice_date);
      console.log("Due Date:", dataSource.due_date);

      // Update form fields to ensure dates are set correctly
      mainForm.setFieldsValue({
        ...dataSource,
      });
    }
  }, [dataSource, loading]);

  useEffect(() => {
    setProductCount(invoiceItemData.length);
  }, [invoiceItemData]);

  // useEffect(() => {
  //     setServiceCount(serviceData.length);
  // }, [serviceData]);

  useEffect(() => {
    const fetchInvoicePdf = async () => {
      if (openViewDrawer && dataSource?.id) {
        setPdfLoading(true);
        try {
          const response = await axios.get(
            `invoices/invoices/${dataSource.id}/invoiceView/`,
            { responseType: 'blob' }
          );
          const blobUrl = URL.createObjectURL(response.data);
          setPdfUrl(blobUrl);
        } catch (error) {
          console.error('Error loading invoice PDF:', error);
          message.error('Failed to load invoice preview');
        } finally {
          setPdfLoading(false);
        }
      } else {
        if (pdfUrl) {
          URL.revokeObjectURL(pdfUrl);
        }
        setPdfUrl("");
      }
    };
    fetchInvoicePdf();
  }, [openViewDrawer, dataSource?.id]);

  useEffect(() => {
    // Switching an invoice to "manual" replaces its lines with a single net
    // figure, so the lines are dropped. Loading an invoice that is already
    // manual must not do that: it would clear lines the invoice still has on
    // the server and the next save would delete them.
    if (loadedIsManualRef.current === isManual) {
      loadedIsManualRef.current = null;
      return;
    }
    if (isManual) {
      let tempNet = net;
      setInvoiceItemData([]);
      setServiceData([]);
      setHasUnsavedChanges(true);
      if (!id) {
        mainForm.setFieldValue("net", tempNet);
      }
    } else {
      //TODO
    }
  }, [isManual]);

  useEffect(() => {
    let tempNet = 0,
      itemTaxes = 0,
      tempTotal = 0;
    let tempTotalTaxes = {};
    if (isManual) {
      tempNet = parseFloat(net);
      if (isNaN(tempNet)) {
        tempNet = 0;
      }
    }
    if (invoiceItemData.length > 0 || serviceData.length > 0) {
      console.log(invoiceItemData);
      // setNet()
      // let tempNet = invoiceItemData?.reduce((n, currentRecord) => {
      //     return (n + currentRecord.line_total);
      // }, 0);
      setNet(tempNet);
      for (let i in invoiceItemData) {
        tempNet += invoiceItemData[i].line_total;
        console.log(invoiceItemData[i].tax_rate1);
        if (invoiceItemData[i].tax_rate1) {
          console.log(taxRates);
          const taxObj = taxRates.find(
            (item) => item.id === invoiceItemData[i].tax_rate1
          );
          console.log(taxObj);
          if (taxObj) {
            if (taxObj.title in tempTotalTaxes) {
              tempTotalTaxes[taxObj.title] +=
                (invoiceItemData[i].line_total * taxObj.rate) / 100;
            } else {
              tempTotalTaxes[taxObj.title] =
                (invoiceItemData[i].line_total * taxObj.rate) / 100;
            }
          }
        }
        if (invoiceItemData[i].tax_rate2) {
          console.log(taxRates);
          const taxObj = taxRates.find(
            (item) => item.id === invoiceItemData[i].tax_rate2
          );
          console.log(taxObj);
          if (taxObj) {
            if (taxObj.title in tempTotalTaxes) {
              tempTotalTaxes[taxObj.title] +=
                (invoiceItemData[i].line_total * taxObj.rate) / 100;
            } else {
              tempTotalTaxes[taxObj.title] =
                (invoiceItemData[i].line_total * taxObj.rate) / 100;
            }
          }
        }
        if (invoiceItemData[i].tax_rate3) {
          console.log(taxRates);
          const taxObj = taxRates.find(
            (item) => item.id === invoiceItemData[i].tax_rate3
          );
          console.log(taxObj);
          if (taxObj) {
            if (taxObj.title in tempTotalTaxes) {
              tempTotalTaxes[taxObj.title] +=
                (invoiceItemData[i].line_total * taxObj.rate) / 100;
            } else {
              tempTotalTaxes[taxObj.title] =
                (invoiceItemData[i].line_total * taxObj.rate) / 100;
            }
          }
        }
      }
      for (let i in serviceData) {
        tempNet += serviceData[i].line_total;
        console.log(serviceData[i].tax_rate1);
        if (serviceData[i].tax_rate1) {
          console.log(taxRates);
          const taxObj = taxRates.find(
            (item) => item.id === serviceData[i].tax_rate1
          );
          console.log(taxObj);
          if (taxObj) {
            if (taxObj.title in tempTotalTaxes) {
              tempTotalTaxes[taxObj.title] +=
                (serviceData[i].line_total * taxObj.rate) / 100;
            } else {
              tempTotalTaxes[taxObj.title] =
                (serviceData[i].line_total * taxObj.rate) / 100;
            }
          }
        }
        if (serviceData[i].tax_rate2) {
          console.log(taxRates);
          const taxObj = taxRates.find(
            (item) => item.id === serviceData[i].tax_rate2
          );
          console.log(taxObj);
          if (taxObj) {
            if (taxObj.title in tempTotalTaxes) {
              tempTotalTaxes[taxObj.title] +=
                (serviceData[i].line_total * taxObj.rate) / 100;
            } else {
              tempTotalTaxes[taxObj.title] =
                (serviceData[i].line_total * taxObj.rate) / 100;
            }
          }
        }
        if (serviceData[i].tax_rate3) {
          console.log(taxRates);
          const taxObj = taxRates.find(
            (item) => item.id === serviceData[i].tax_rate3
          );
          console.log(taxObj);
          if (taxObj) {
            if (taxObj.title in tempTotalTaxes) {
              tempTotalTaxes[taxObj.title] +=
                (serviceData[i].line_total * taxObj.rate) / 100;
            } else {
              tempTotalTaxes[taxObj.title] =
                (serviceData[i].line_total * taxObj.rate) / 100;
            }
          }
        }
      }
      for (const [, value] of Object.entries(tempTotalTaxes)) {
        itemTaxes += value;
      }
      // Overall discount comes off the net before the invoice-level taxes.
      const overallDiscount = discountAmountOf(tempNet, discountType, discountValue);
      const taxableNet = tempNet - overallDiscount;
      setDiscountAmount(overallDiscount);
      let netTaxes = 0;
      if (taxRate1) {
        const taxObj = taxRates.find((item) => item.id === taxRate1.id);
        console.log(taxObj);
        if (taxObj) {
          if (taxObj.title in tempTotalTaxes) {
            tempTotalTaxes[taxObj.title] += (taxableNet * taxObj.rate) / 100;
          } else {
            tempTotalTaxes[taxObj.title] = (taxableNet * taxObj.rate) / 100;
          }
          netTaxes += (taxableNet * taxObj.rate) / 100;
        }
      }
      if (taxRate2) {
        const taxObj = taxRates.find((item) => item.id === taxRate2.id);
        console.log(taxObj);
        if (taxObj) {
          if (taxObj.title in tempTotalTaxes) {
            tempTotalTaxes[taxObj.title] += (taxableNet * taxObj.rate) / 100;
          } else {
            tempTotalTaxes[taxObj.title] = (taxableNet * taxObj.rate) / 100;
          }
          netTaxes += (taxableNet * taxObj.rate) / 100;
        }
      }
      if (taxRate3) {
        const taxObj = taxRates.find((item) => item.id === taxRate3.id);
        console.log(taxObj);
        if (taxObj) {
          if (taxObj.title in tempTotalTaxes) {
            tempTotalTaxes[taxObj.title] += (taxableNet * taxObj.rate) / 100;
          } else {
            tempTotalTaxes[taxObj.title] = (taxableNet * taxObj.rate) / 100;
          }
          netTaxes += (taxableNet * taxObj.rate) / 100;
        }
      }
      setNet(tempNet);
      setTotalTaxes(tempTotalTaxes);
      // setSubTotal(tempNet + itemTaxes);
      let urt = parseFloat(taxableNet + itemTaxes + netTaxes).toFixed(2);
      let tot = Math.round(urt);
      let rof = (tot - urt).toFixed(2);
      setUnRoundedTotal(urt);
      setRoundValue(rof);
      setTotal(tot);
    } else {
      // setSubTotal(0);
      // Overall discount comes off the net before the invoice-level taxes.
      const overallDiscount = discountAmountOf(tempNet, discountType, discountValue);
      const taxableNet = tempNet - overallDiscount;
      setDiscountAmount(overallDiscount);
      let netTaxes = 0;
      if (taxRate1) {
        const taxObj = taxRates.find((item) => item.id === taxRate1.id);
        console.log(taxObj);
        if (taxObj) {
          if (taxObj.title in tempTotalTaxes) {
            tempTotalTaxes[taxObj.title] += (taxableNet * taxObj.rate) / 100;
          } else {
            tempTotalTaxes[taxObj.title] = (taxableNet * taxObj.rate) / 100;
          }
          netTaxes += (taxableNet * taxObj.rate) / 100;
        }
      }
      if (taxRate2) {
        const taxObj = taxRates.find((item) => item.id === taxRate2.id);
        console.log(taxObj);
        if (taxObj) {
          if (taxObj.title in tempTotalTaxes) {
            tempTotalTaxes[taxObj.title] += (taxableNet * taxObj.rate) / 100;
          } else {
            tempTotalTaxes[taxObj.title] = (taxableNet * taxObj.rate) / 100;
          }
          netTaxes += (taxableNet * taxObj.rate) / 100;
        }
      }
      if (taxRate3) {
        const taxObj = taxRates.find((item) => item.id === taxRate3.id);
        console.log(taxObj);
        if (taxObj) {
          if (taxObj.title in tempTotalTaxes) {
            tempTotalTaxes[taxObj.title] += (taxableNet * taxObj.rate) / 100;
          } else {
            tempTotalTaxes[taxObj.title] = (taxableNet * taxObj.rate) / 100;
          }
          netTaxes += (taxableNet * taxObj.rate) / 100;
        }
      }
      console.log({
        ...dataSource,
        invoice_date: dataSource?.invoice_date
          ? dayjs(dataSource?.invoice_date)
          : null,
        due_date: dataSource?.due_date ? dayjs(dataSource?.due_date) : null,
      });
      console.log({ tempNet, tempTotalTaxes, tempTotal, itemTaxes, netTaxes });
      setNet(tempNet);
      setTotalTaxes(tempTotalTaxes);
      // setSubTotal(tempNet + itemTaxes);
      let urt = parseFloat(taxableNet + itemTaxes + netTaxes).toFixed(2);
      let tot = Math.round(urt);
      let rof = (tot - urt).toFixed(2);
      setUnRoundedTotal(urt);
      setRoundValue(rof);
      setTotal(tot);
    }

    // Calculate total hours and days
    let tempTotalHours = 0;
    let tempTotalDays = 0;

    for (let item of invoiceItemData) {
      if (item.unit === "HOURS") {
        tempTotalHours += parseFloat(item.quantity) || 0;
      } else if (item.unit === "DAYS") {
        tempTotalDays += parseFloat(item.quantity) || 0;
      }
    }

    for (let item of serviceData) {
      if (item.unit === "HOURS") {
        tempTotalHours += parseFloat(item.quantity) || 0;
      } else if (item.unit === "DAYS") {
        tempTotalDays += parseFloat(item.quantity) || 0;
      }
    }

    setTotalHours(tempTotalHours);
    setTotalDays(tempTotalDays);
  }, [invoiceItemData, serviceData, taxRate1, taxRate2, taxRate3, net, discountType, discountValue]);

  // Total payable follows the currency: whole rupees for INR, cents kept for
  // other currencies (same rule as the backend's total_payable).
  useEffect(() => {
    const tot = roundPayable(unRoundedTotal, selectedCurrencyIso || "INR");
    setTotal(tot);
    setRoundValue((tot - Number(unRoundedTotal || 0)).toFixed(2));
  }, [unRoundedTotal, selectedCurrencyIso]);

  // Handle page leave confirmation
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (hasUnsavedChanges) {
        e.preventDefault();
        e.returnValue = "You have unsaved changes. Are you sure you want to leave?";
        return "You have unsaved changes. Are you sure you want to leave?";
      }
    };

    const handlePopState = (e) => {
      if (hasUnsavedChanges) {
        const confirmLeave = window.confirm("You have unsaved changes. Are you sure you want to leave?");
        if (!confirmLeave) {
          e.preventDefault();
          window.history.pushState(null, "", window.location.href);
        }
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('popstate', handlePopState);

    // Push current state to prevent back navigation without warning
    if (hasUnsavedChanges) {
      window.history.pushState(null, "", window.location.href);
    }

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('popstate', handlePopState);
    };
  }, [hasUnsavedChanges]);

  // Handle navigation attempts by overriding link clicks
  useEffect(() => {
    const handleLinkClick = (e) => {
      // Check if it's a navigation link
      const target = e.target.closest('a[href]');
      if (target && hasUnsavedChanges) {
        const href = target.getAttribute('href');
        // Only block internal navigation links, not external ones
        if (href && href.startsWith('/') && href !== window.location.pathname) {
          console.log("Navigation link clicked, checking for unsaved changes");
          if (!window.confirm("You have unsaved changes. Are you sure you want to leave?")) {
            e.preventDefault();
            e.stopPropagation();
            return false;
          }
        }
      }
    };

    document.addEventListener('click', handleLinkClick, true);
    return () => {
      document.removeEventListener('click', handleLinkClick, true);
    };
  }, [hasUnsavedChanges]);

  // Track form changes
  const handleFormChange = () => {
    console.log("Invoice form changed - setting unsaved changes to true");
    setHasUnsavedChanges(true);
  };

  // Wrapper function to track invoice item changes
  const updateInvoiceItemData = (newData) => {
    console.log("Invoice items changed - setting unsaved changes to true");
    setInvoiceItemData(newData);
    setHasUnsavedChanges(true);
  };

  // The unsaved-changes flag is set by the handlers that actually change
  // something. Watching invoiceItemData/net/total instead raised the flag on
  // every load and re-raised it straight after a successful save, since both
  // recompute those values.

  return (
    <div
      className="custom-scroll-div"
      style={{
        overflowY: "scroll",
        maxHeight: "90vh",
        padding: 24,
        paddingBottom: 30,
      }}
    >
      {!loading && (
        <Form
          form={mainForm}
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 18 }}
          onFinish={onFinish}
          onValuesChange={handleFormChange}
          initialValues={{
            ...dataSource,
          }}
        >
          <Flex justify="end" gap="middle" style={{ margin: "10px auto" }}>
            {(() => {
              const items = [];
              if (id) {
                if (!isManual) {
                  items.push({
                    key: 'print',
                    icon: <PrinterOutlined />,
                    label: 'Print Invoice',
                    onClick: () => setOpenViewDrawer(true),
                  });
                  items.push({
                    key: 'download',
                    label: 'Download Invoice',
                    onClick: () => previewDownloadPdf(false, true),
                  });
                  items.push({
                    key: 'clone',
                    label: 'Clone',
                    onClick: () => setCloneDialogVisible(true),
                  });
                }
                items.push({
                  key: 'send',
                  label: 'Send Invoice',
                  onClick: () => setOpenSendDrawer(true),
                });
                items.push({
                  key: 'view',
                  label: 'View Invoice',
                  onClick: () => setOpenViewDrawer(true),
                });
                items.push({
                  key: 'record-payment',
                  label: 'Record Payment',
                  onClick: () => navigate(`/payments/new?invoice_id=${id}&invoice_number=${dataSource?.inv_number}&account_id=${dataSource?.account}`),
                });
                items.push({
                  key: 'credit-note',
                  label: 'Create Credit Note',
                  onClick: () => navigate(`/credit-notes/new?invoice_id=${id}`),
                });
                items.push({
                  key: 'debit-note',
                  label: 'Create Debit Note',
                  onClick: () => navigate(`/debit-notes/new?invoice_id=${id}`),
                });
                items.push({
                  key: 'create-quote',
                  label: 'Create Quote',
                  onClick: async () => {
                    try {
                      const response = await adminactions.createQuoteFromInvoice(id);
                      if (response) {
                        message.success(`Quote ${response.qt_number} created successfully`);
                        navigate(`/quotes/edit/${response.id}`);
                      }
                    } catch (err) {
                      message.error("Failed to create quote from invoice");
                    }
                  },
                });
              }
              items.push({
                key: 'schedule-reminder',
                label: (
                  <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <span
                      style={{
                        width: 8,
                        height: 8,
                        borderRadius: '50%',
                        backgroundColor: scheduledReminders.length > 0 ? '#52c41a' : '#ff4d4f',
                      }}
                    />
                    Schedule Reminder
                  </span>
                ),
                onClick: () => {
                  const paymentTerm = mainForm.getFieldValue('payment_term');
                  if (!paymentTerm) {
                    message.warning('Payment term is not selected. Please select a payment term first.');
                    return;
                  }
                  setScheduleReminderModalOpen(true);
                },
              });
              return (
                <Dropdown menu={{ items }} placement="bottomRight" trigger={['click']}>
                  <Button htmlType="button">
                    Actions <DownOutlined />
                  </Button>
                </Dropdown>
              );
            })()}
            <Button type="primary" htmlType="submit" loading={submitting}>
              Save
            </Button>
          </Flex>

          <Row>
            <Col span={8}>
              <div className="site-card-border-less-wrapper">
                <Card title="Account" bordered={false}>
                  <div>
                    <Form.Item label="Account">
                      <Space.Compact style={{ width: "100%" }}>
                        <Button
                          icon={<PlusOutlined />}
                          title="Add Account"
                          onClick={() => setQuickAddAccountOpen(true)}
                        />
                        <Form.Item name="account" noStyle>
                          <Select
                            showSearch
                            allowClear
                            style={{ width: "100%" }}
                            placeholder="Select Account (Optional)"
                            optionFilterProp="children"
                            onChange={(value) => {
                              onAccountChange(value);
                              // Filter quotes by selected account
                              loadQuotes(value);
                              // Clear quote selection when account changes
                              mainForm.setFieldValue("quote", null);
                            }}
                            onSearch={onAccountSearch}
                            filterOption={(input, option) =>
                              (option?.label ?? "")
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                            options={accounts?.map((item, index) => {
                              return { value: item.id, label: item.name };
                            })}
                          />
                        </Form.Item>
                      </Space.Compact>
                    </Form.Item>
                  </div>
                  <div>
                    <Form.Item
                      label="Quote"
                      name="quote"
                    >
                      <Select
                        showSearch
                        allowClear
                        placeholder="Select Quote (Optional)"
                        optionFilterProp="children"
                        disabled={!!dataSource?.quote}
                        filterOption={(input, option) =>
                          (option?.label ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        options={quotes?.map((item, index) => {
                          return { value: item.id, label: item.qt_number };
                        })}
                      />
                    </Form.Item>
                  </div>
                  <div>
                    <Form.Item
                      label="Product"
                      name="product"
                      tooltip="Tag this invoice to a Teson product (e.g. SignVerse, PhotoStore). Optional."
                    >
                      <Select
                        showSearch
                        allowClear
                        placeholder="Select Product (Optional)"
                        optionFilterProp="label"
                        filterOption={(input, option) =>
                          (option?.label ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        options={tesonProducts?.map((item) => ({
                          value: item.id,
                          label: item.code ? `${item.name} (${item.code})` : item.name,
                        }))}
                      />
                    </Form.Item>
                  </div>
                  <div>
                    <Form.Item
                      label="Status"
                      name="status"
                      rules={[{ required: true }]}
                    >
                      <Select
                        placeholder="Select Status"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option?.label ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        options={invoiceStatuses.map((item, index) => {
                          return { value: item[0], label: item[0] };
                        })}
                      />
                    </Form.Item>
                  </div>
                </Card>
              </div>
            </Col>
            <Col span={8} style={{ padding: "0px 0px 10px 10px" }}>
              <div className="site-card-border-less-wrapper">
                <Card bordered={false}>
                  <Form.Item label="Invoice Date" name="invoice_date">
                    <DatePicker
                      key={`invoice-date-${dataSource?.id || 'new'}-${dataSource?.invoice_date?.format?.('YYYY-MM-DD') || 'none'}`}
                      onChange={handleInvoiceDateChange}
                      format={dateFormat}
                      style={{ width: '100%' }}
                      placeholder="Select Invoice Date"
                      showToday
                    />
                  </Form.Item>
                  <Form.Item label="Payment Term" name="payment_term">
                    <Select
                      showSearch
                      placeholder="Select Payment Term"
                      options={paymentTerms.map((term) => ({
                        value: term.id,
                        label: `${term.name}`,
                      }))}
                      onChange={handlePaymentTermChange}
                    />
                  </Form.Item>
                  <Form.Item label="Due Date" name="due_date">
                    <DatePicker
                      key={`due-date-${dataSource?.id || 'new'}-${dataSource?.due_date?.format?.('YYYY-MM-DD') || 'none'}`}
                      format={dateFormat}
                      style={{ width: '100%' }}
                      placeholder="Select Due Date"
                      showToday
                    />
                  </Form.Item>
                  <Form.Item label="Currency" name="currency">
                    <Select
                      showSearch
                      placeholder="Select Currency"
                      optionFilterProp="label"
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? "")
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? "").toLowerCase())
                      }
                      options={currencies.map((currency) => ({
                        value: currency.id,
                        label: `${currency.currency} (${currency.iso_code})`,
                      }))}
                      onChange={(value) => {
                        const curr = currencies.find((c) => c.id === value);
                        const iso = curr?.iso_code || null;
                        setSelectedCurrencyIso(iso);
                        if (iso === 'INR') {
                          mainForm.setFieldsValue({ exchange_rate: 1.0 });
                        }
                      }}
                    />
                  </Form.Item>
                  {selectedCurrencyIso && selectedCurrencyIso !== 'INR' && (
                    <Form.Item
                      label={<span style={{ whiteSpace: 'normal' }}>Exchange Rate</span>}
                      name="exchange_rate"
                      rules={[{ required: true, message: "Please enter the exchange rate" }]}
                    >
                      <ExchangeRateInput
                        currencyIso={selectedCurrencyIso}
                        savedRate={
                          dataSource?.currency && dataSource.currency === selectedCurrencyId
                            ? dataSource.exchange_rate
                            : undefined
                        }
                      />
                    </Form.Item>
                  )}
                </Card>
              </div>
            </Col>
            <Col span={8} style={{ padding: "0px 0px 10px 10px" }}>
              <div className="site-card-border-less-wrapper">
                <Card bordered={false}>
                  <Form.Item
                    label="Invoice Number"
                    name="inv_number"
                    labelCol={{ span: 8 }}
                  >
                    <Input
                      onChange={() => { invNumberEdited.current = true; }}
                      suffix={
                        <Button
                          type="text"
                          icon={<ReloadOutlined />}
                          onClick={() => loadGeneratedInvoiceNumber()}
                          size="small"
                          title="Generate invoice number for the invoice date's month"
                        />
                      }
                    />
                  </Form.Item>
                  <Form.Item
                    label="PO Number"
                    name="po_number"
                    labelCol={{ span: 8 }}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    label="Is Manual"
                    name="is_manual"
                    valuePropName="checked"
                    labelCol={{ span: 8 }}
                  >
                    <Switch
                      onChange={(value) => setIsManual(value)}
                      disabled={id ? true : false}
                    />
                  </Form.Item>
                  <Form.Item
                    label={<span style={{ whiteSpace: 'normal' }}>Org Bank Account</span>}
                    name="org_bank_account"
                    rules={[{ required: true, message: "Please select an organization bank account!" }]}
                  >
                    <Select
                      placeholder="Select Org Bank Account"
                      options={bankAccounts.map((org_bank_account) => ({
                        value: org_bank_account.id,
                        label: `${org_bank_account.account_name} (${org_bank_account.bank_name} ${org_bank_account.account_number})`,
                      }))}
                    />
                  </Form.Item>
                </Card>
              </div>
            </Col>
          </Row>

          {/* Invoice Options Section */}
          <Row style={{ marginTop: 10 }}>
            <Col span={24}>
              <Card title="Invoice Options" bordered={false}>
                <Row gutter={24}>
                  <Col xs={12} sm={6}>
                    <Form.Item
                      label="Show Bank Details"
                      name="show_bank_details"
                      valuePropName="checked"
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                    >
                      <Switch />
                    </Form.Item>
                  </Col>
                  <Col xs={12} sm={6}>
                    <Form.Item
                      label="Computer Generated"
                      name="is_computer_generated"
                      valuePropName="checked"
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                    >
                      <Switch />
                    </Form.Item>
                  </Col>
                  <Col xs={12} sm={6}>
                    <Form.Item
                      label="Authorized Signature"
                      name="is_authorized_signature_required"
                      valuePropName="checked"
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                    >
                      <Switch />
                    </Form.Item>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>

          {/* Customer Information Section */}
          <Row style={{ marginTop: 10 }}>
            <Col span={24}>
              <Card
                title="Customer Information"
                bordered={false}
                extra={isAccountSelected && <span style={{ color: '#1890ff', fontSize: 12 }}>Auto-populated from Account</span>}
              >
                <Row gutter={16}>
                  <Col span={8}>
                    <Form.Item
                      label="Legal Name"
                      name="legal_name_of_business"
                      labelCol={{ span: 8 }}
                    >
                      <Input disabled={isAccountSelected} placeholder="Customer Legal Name" />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item
                      label="GST Number"
                      name="gst_number"
                      labelCol={{ span: 8 }}
                    >
                      <Input disabled={isAccountSelected} placeholder="GST Number" />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item
                      label="Place of Supply"
                      name="place_of_supply"
                      labelCol={{ span: 8 }}
                    >
                      <Select
                        showSearch
                        disabled={isAccountSelected}
                        placeholder="Select State"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option?.label ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        options={states?.map((item) => ({
                          value: item.id,
                          label: item.name,
                        }))}
                      />
                    </Form.Item>
                  </Col>
                </Row>

                <Row gutter={16}>
                  <Col span={12}>
                    <Card title="Billing Address" size="small" style={{ marginTop: 10 }}>
                      <Form.Item
                        label="Address Line 1"
                        name="billing_address1"
                        labelCol={{ span: 8 }}
                      >
                        <Input disabled={isAccountSelected} placeholder="Address Line 1" />
                      </Form.Item>
                      <Form.Item
                        label="Address Line 2"
                        name="billing_address2"
                        labelCol={{ span: 8 }}
                      >
                        <Input disabled={isAccountSelected} placeholder="Address Line 2" />
                      </Form.Item>
                      <Form.Item
                        label="City"
                        name="billing_city"
                        labelCol={{ span: 8 }}
                      >
                        <Input disabled={isAccountSelected} placeholder="City" />
                      </Form.Item>
                      <Form.Item
                        label="State"
                        name="billing_state"
                        labelCol={{ span: 8 }}
                      >
                        <Input disabled={isAccountSelected} placeholder="State" />
                      </Form.Item>
                      <Form.Item
                        label="Postal Code"
                        name="billing_postal_code"
                        labelCol={{ span: 8 }}
                      >
                        <Input disabled={isAccountSelected} placeholder="Postal Code" />
                      </Form.Item>
                      <Form.Item
                        label="Country"
                        name="billing_country"
                        labelCol={{ span: 8 }}
                      >
                        <Select
                          showSearch
                          disabled={isAccountSelected}
                          placeholder="Select Country"
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            (option?.label ?? "")
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                          options={countries?.map((item) => ({
                            value: item.id,
                            label: item.name,
                          }))}
                        />
                      </Form.Item>
                      <Form.Item
                        label="Phone"
                        name="billing_phone"
                        labelCol={{ span: 8 }}
                      >
                        <Input disabled={isAccountSelected} placeholder="Phone Number" />
                      </Form.Item>
                    </Card>
                  </Col>

                  <Col span={12}>
                    <Card title="Shipping Address" size="small" style={{ marginTop: 10 }}>
                      <Form.Item
                        label="Address Line 1"
                        name="shipping_address1"
                        labelCol={{ span: 8 }}
                      >
                        <Input disabled={isAccountSelected} placeholder="Address Line 1" />
                      </Form.Item>
                      <Form.Item
                        label="Address Line 2"
                        name="shipping_address2"
                        labelCol={{ span: 8 }}
                      >
                        <Input disabled={isAccountSelected} placeholder="Address Line 2" />
                      </Form.Item>
                      <Form.Item
                        label="City"
                        name="shipping_city"
                        labelCol={{ span: 8 }}
                      >
                        <Input disabled={isAccountSelected} placeholder="City" />
                      </Form.Item>
                      <Form.Item
                        label="State"
                        name="shipping_state"
                        labelCol={{ span: 8 }}
                      >
                        <Input disabled={isAccountSelected} placeholder="State" />
                      </Form.Item>
                      <Form.Item
                        label="Postal Code"
                        name="shipping_postal_code"
                        labelCol={{ span: 8 }}
                      >
                        <Input disabled={isAccountSelected} placeholder="Postal Code" />
                      </Form.Item>
                      <Form.Item
                        label="Country"
                        name="shipping_country"
                        labelCol={{ span: 8 }}
                      >
                        <Select
                          showSearch
                          disabled={isAccountSelected}
                          placeholder="Select Country"
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            (option?.label ?? "")
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                          options={countries?.map((item) => ({
                            value: item.id,
                            label: item.name,
                          }))}
                        />
                      </Form.Item>
                      <Form.Item
                        label="Phone"
                        name="shipping_phone"
                        labelCol={{ span: 8 }}
                      >
                        <Input disabled={isAccountSelected} placeholder="Phone Number" />
                      </Form.Item>
                    </Card>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col span={24}>
              {!isManual && (
                <div className="site-card-border-less-wrapper">
                  <Card bordered={false} style={{}}>
                    <Tabs
                      defaultActiveKey="1"
                      onChange={onChange}
                      tabBarExtraContent={
                        <Space>
                          {/* Exporting needs a saved invoice to read the lines from. */}
                          <Button
                            onClick={handleExportInvoiceLines}
                            icon={<DownloadOutlined />}
                            loading={exporting}
                            disabled={!id || invoiceItemData.length === 0}
                            title={
                              !id
                                ? "Save the invoice before exporting its lines"
                                : "Download these lines as Excel, edit them, and import the file back"
                            }
                          >
                            Export to Excel
                          </Button>
                          <Button
                            onClick={() => setImportModalOpen(true)}
                            icon={<InboxOutlined />}
                          >
                            Import from Excel
                          </Button>
                        </Space>
                      }
                      items={[
                        {
                          label: `Invoice Lines`,
                          key: "1",
                          children: (
                            <div>
                              <Form form={productForm} component={false}>
                                <DndContext sensors={sensors} modifiers={[restrictToVerticalAxis]} onDragEnd={onDragEnd}>
                                  <SortableContext
                                    // rowKey array
                                    items={invoiceItemData?.map((i) => i.key)}
                                    strategy={verticalListSortingStrategy}
                                  >
                                    <Table
                                      // components={{
                                      //     body: {
                                      //         cell: ProductEditableCell,
                                      //     },
                                      // }}
                                      components={{
                                        body: {
                                          row: TableRow,
                                        },
                                      }}
                                      dataSource={invoiceItemData}
                                      columns={mergedColumns}
                                      rowClassName="editable-row"
                                      size="small"
                                      pagination={false}
                                      rowKey={(row) => row.key}
                                      style={{ position: 'relative', zIndex: 1 }}
                                    />
                                  </SortableContext>
                                </DndContext>
                                <Button
                                  // onClick={handleAddProduct}
                                  onClick={() => {
                                    setCurrentProductInstance(null);
                                    productForm.resetFields();
                                    setOpenInvoiceItemForm(true);
                                  }}
                                  type="primary"
                                  style={{
                                    marginBottom: 16,
                                  }}
                                >
                                  Add Item
                                </Button>
                              </Form>
                            </div>
                          ),
                        },
                      ]}
                    />
                  </Card>
                </div>
              )}
              {isManual && (
                <div className="site-card-border-less-wrapper">
                  <Row>
                    <Col span={8}>
                      <Card bordered={false}>
                        <Form.Item label="Net" name="net">
                          <Input
                            onChange={(e) => {
                              setNet(e.target.value);
                            }}
                          />
                        </Form.Item>
                      </Card>
                    </Col>
                  </Row>
                </div>
              )}
            </Col>
          </Row>
          <Row style={{ padding: "10px 0px 0px 0px" }}>
            <Col span={16}>
              {id && (
                <div className="site-card-border-less-wrapper">
                  <Card bordered={false} style={{}}>
                    <Tabs
                      defaultActiveKey="1"
                      onChange={onChange}
                      items={[
                        {
                          label: `Public Notes`,
                          key: "1",
                          children: (
                            <div>
                              <Form.Item
                                valuePropName="data"
                                name="public_notes"
                                getValueFromEvent={(event) => {
                                  const data = event.editor.getData();
                                  return data;
                                }}
                              >
                                <CKEditor
                                  initData={
                                    dataSource
                                      ? dataSource.public_notes
                                      : "<p>Create your Template here!</p>"
                                  }
                                  config={editorConfig}
                                  editorUrl={
                                    process.env.REACT_APP_BASE_URL +
                                    "/staticfiles/ckeditor/4.19.0/full-all/ckeditor.js"
                                  }
                                />
                              </Form.Item>
                            </div>
                          ),
                        },
                        {
                          label: `Private Notes`,
                          key: "2",
                          children: (
                            <div>
                              <Form.Item
                                valuePropName="data"
                                name="private_notes"
                                getValueFromEvent={(event) => {
                                  const data = event.editor.getData();
                                  return data;
                                }}
                              >
                                <CKEditor
                                  initData={
                                    dataSource
                                      ? dataSource.private_notes
                                      : "<p>Create your Template here!</p>"
                                  }
                                  config={editorConfig}
                                  editorUrl={
                                    process.env.REACT_APP_BASE_URL +
                                    "/staticfiles/ckeditor/4.19.0/full-all/ckeditor.js"
                                  }
                                />
                              </Form.Item>
                            </div>
                          ),
                        },
                        {
                          label: `Terms`,
                          key: "3",
                          children: (
                            <div>
                              <Form.Item
                                valuePropName="data"
                                name="terms"
                                getValueFromEvent={(event) => {
                                  const data = event.editor.getData();
                                  return data;
                                }}
                              >
                                <CKEditor
                                  initData={
                                    dataSource
                                      ? dataSource.terms
                                      : "<p>Create your Template here!</p>"
                                  }
                                  config={editorConfig}
                                  editorUrl={
                                    process.env.REACT_APP_BASE_URL +
                                    "/staticfiles/ckeditor/4.19.0/full-all/ckeditor.js"
                                  }
                                />
                              </Form.Item>
                            </div>
                          ),
                        },
                        {
                          label: `Documents`,
                          key: "5",
                          children: (
                            <div>
                              <Row>
                                <Col span={12}>
                                  <DocumentPicker
                                    selectDocuments={handleAddDocument}
                                  />
                                </Col>
                                <Col span={12}>
                                  <Dragger {...props}>
                                    <p className="ant-upload-drag-icon">
                                      <InboxOutlined />
                                    </p>
                                    <p className="ant-upload-text">
                                      Click or drag file to this area to upload
                                    </p>
                                    <p className="ant-upload-hint">
                                      Support for a single or bulk upload.
                                      Strictly prohibit from uploading company
                                      data or other band files
                                    </p>
                                  </Dragger>
                                </Col>
                              </Row>
                              <Table
                                dataSource={documents}
                                columns={documentColumns}
                                rowClassName="editable-row"
                                size="small"
                                pagination={false}
                              />
                            </div>
                          ),
                        },
                        {
                          label: `Attachments`,
                          key: "6",
                          children: (
                            <div>
                              <Row>
                                <Col span={12}>
                                  <DocumentPicker
                                    selectDocuments={handleAddDocument}
                                  />
                                </Col>
                                <Col span={12}>
                                  <Dragger {...props}>
                                    <p className="ant-upload-drag-icon">
                                      <InboxOutlined />
                                    </p>
                                    <p className="ant-upload-text">
                                      Click or drag file to this area to upload
                                    </p>
                                    <p className="ant-upload-hint">
                                      Support for a single or bulk upload.
                                      Strictly prohibit from uploading company
                                      data or other band files
                                    </p>
                                  </Dragger>
                                </Col>
                              </Row>
                              <Table
                                dataSource={attachments}
                                columns={attachmentColumns}
                                rowClassName="editable-row"
                                size="small"
                                pagination={false}
                              />
                            </div>
                          ),
                        },
                        // {
                        //     label: `Bank Information`,
                        //     key: '7',
                        //     children:
                        //         (<div
                        //         >
                        //             <Form.Item label="Bank Account Number" name='bank_account_number'>
                        //                 <Input />
                        //             </Form.Item>
                        //             <Form.Item label="Bank Name" name='bank_name'>
                        //                 <Input />
                        //             </Form.Item>
                        //             <Form.Item label="IFSC Code" name='bank_ifsc'>
                        //                 <Input />
                        //             </Form.Item>
                        //             <Form.Item label="Bank Branch" name='bank_branch'>
                        //                 <Input />
                        //             </Form.Item>
                        //         </div>),
                        // },
                      ]}
                    />
                  </Card>
                </div>
              )}
            </Col>
            <Col span={8} style={{ padding: "0px 0px 10px 10px" }}>
              <div className="site-card-border-less-wrapper">
                {(totalHours > 0 || totalDays > 0) && (
                  <Card bordered={false} style={{ marginBottom: 10, textAlign: "left" }}>
                    <h2>Timeline</h2>
                    {totalHours > 0 && (
                      <Form.Item label="Total Hours" style={{marginBottom: 0}}>
                        <span>{totalHours}</span>
                      </Form.Item>
                    )}
                    {totalDays > 0 && (
                      <Form.Item label="Total Days" style={{marginBottom: 0}}>
                        <span>{totalDays}</span>
                      </Form.Item>
                    )}
                  </Card>
                )}
                <Card bordered={false} style={{textAlign: "left"}}>
                  <Form.Item label="Net">
                    <span>{net}</span>
                  </Form.Item>
                  <Form.Item label="Discount Type" name="discount_type">
                    <Select
                      placeholder="No discount"
                      allowClear
                      options={DISCOUNT_TYPE_OPTIONS}
                      onChange={(value) => {
                        if (!value) {
                          mainForm.setFieldsValue({ discount_value: null });
                        }
                      }}
                    />
                  </Form.Item>
                  {discountType && (
                    <Form.Item
                      label="Discount"
                      name="discount_value"
                      rules={[{ required: true, message: "Please enter the discount" }]}
                    >
                      <InputNumber
                        min={0}
                        max={discountType === "PERCENT" ? 100 : undefined}
                        step={0.01}
                        precision={2}
                        style={{ width: "100%" }}
                        addonAfter={discountType === "PERCENT" ? "%" : undefined}
                      />
                    </Form.Item>
                  )}
                  {discountAmount > 0 && (
                    <>
                      <Form.Item label="Discount Amount">
                        <span>-{Number(discountAmount).toFixed(2)}</span>
                      </Form.Item>
                      <Form.Item label="Net after Discount">
                        <span>{(Number(net) - Number(discountAmount)).toFixed(2)}</span>
                      </Form.Item>
                    </>
                  )}
                  <div>
                    {getTaxes(Object.entries(totalTaxes)).map((item) => {
                      return (
                        <Form.Item label={item.key}>
                          <span>{item.value}</span>
                        </Form.Item>
                      );
                    })}
                  </div>
                  {/* <Form.Item label="Sub Total">
                                        <span>{subtotal}</span>
                                    </Form.Item> */}
                  <Form.Item label="Tax" name="tax_rate1">
                    <Select
                      showSearch
                      placeholder="Select Tax Rate"
                      optionFilterProp="children"
                      allowClear
                      onChange={(value) => {
                        const taxRate = taxRates.find(
                          (item) => item.id === value
                        );
                        console.log(taxRate);
                        setTaxRate1(taxRate);
                        // form.setFieldsValue({ "description": product.notes, "price": product.price, "quantity": 1, "line_total": product.price });
                      }}
                      onSearch={onAccountSearch}
                      filterOption={(input, option) =>
                        (option?.label ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      options={taxRates?.map((item, index) => {
                        return {
                          value: item.id,
                          label: `${item.title + " " + item.rate} %`,
                        };
                      })}
                    />
                  </Form.Item>
                  <Form.Item label="Tax" name="tax_rate2">
                    <Select
                      showSearch
                      placeholder="Select Tax Rate"
                      optionFilterProp="children"
                      allowClear
                      onChange={(value) => {
                        const taxRate = taxRates.find(
                          (item) => item.id === value
                        );
                        console.log(taxRate);
                        // form.setFieldsValue({ "description": product.notes, "price": product.price, "quantity": 1, "line_total": product.price });
                        setTaxRate2(taxRate);
                      }}
                      onSearch={onAccountSearch}
                      filterOption={(input, option) =>
                        (option?.label ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      options={taxRates?.map((item, index) => {
                        return {
                          value: item.id,
                          label: `${item.title + " " + item.rate} %`,
                        };
                      })}
                    />
                  </Form.Item>
                  <Form.Item label="Tax" name="tax_rate3">
                    <Select
                      showSearch
                      placeholder="Select Tax Rate"
                      optionFilterProp="children"
                      allowClear
                      onChange={(value) => {
                        const taxRate = taxRates.find(
                          (item) => item.id === value
                        );
                        console.log(taxRate);
                        setTaxRate3(taxRate);
                        // form.setFieldsValue({ "description": product.notes, "price": product.price, "quantity": 1, "line_total": product.price });
                      }}
                      onSearch={onAccountSearch}
                      filterOption={(input, option) =>
                        (option?.label ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      options={taxRates?.map((item, index) => {
                        return {
                          value: item.id,
                          label: `${item.title + " " + item.rate} %`,
                        };
                      })}
                    />
                  </Form.Item>
                  <Form.Item label="Total:">
                    <span>{unRoundedTotal}</span>
                  </Form.Item>
                  <Form.Item label="Round off:">
                    <span>{roundValue}</span>
                  </Form.Item>
                  <Form.Item label="Total Amount:">
                    <span>{total}</span>
                  </Form.Item>
                </Card>
              </div>
            </Col>
          </Row>

          {/* Link Advance Payments Section */}
          {id && unlinkedPayments.length > 0 && (
            <Card
              title={
                <Space>
                  <LinkOutlined />
                  <span>Link Advance Payments</span>
                </Space>
              }
              style={{ marginTop: 24 }}
              size="small"
            >
              <Table
                dataSource={unlinkedPayments}
                rowKey="id"
                size="small"
                pagination={false}
                columns={[
                  {
                    title: 'Date',
                    dataIndex: 'payment_date',
                    render: (val) => val ? dayjs(val).format('DD MMM YYYY') : '-',
                  },
                  {
                    title: 'Amount',
                    dataIndex: 'amount',
                    render: (val, record) => {
                      // `amount` is always INR; show the original foreign amount too.
                      const iso = recordCurrency(record);
                      return iso !== 'INR' && record.original_amount != null
                        ? `${formatMoney(record.original_amount, iso)} (${formatMoney(val, 'INR')})`
                        : formatMoney(val, 'INR');
                    },
                  },
                  {
                    title: 'Mode',
                    dataIndex: 'payment_mode',
                  },
                  {
                    title: 'Type',
                    dataIndex: 'payment_type',
                  },
                  {
                    title: 'Reference',
                    dataIndex: 'transaction_ref',
                    render: (val) => val || '-',
                  },
                  {
                    title: 'Action',
                    render: (_, record) => (
                      <Button
                        type="link"
                        icon={<LinkOutlined />}
                        loading={linkingPaymentId === record.id}
                        onClick={() => handleLinkPayment(record.id)}
                      >
                        Link
                      </Button>
                    ),
                  },
                ]}
              />
            </Card>
          )}
        </Form>
      )}

      {/* Pdf Preview Modal Start */}
      <PdfPreviewModal
        numPages={numPages}
        onDocumentLoadSuccess={events.onDocumentLoadSuccess}
        pdfPreviewData={pdfPreviewData}
        previewPdfVisible={previewPdfVisible}
        setPreviewPdfVisible={setPreviewPdfVisible}
      />
      {/* Pdf Preview Modal End */}

      <Drawer
        title={`${"Send Invoice"}`}
        placement="right"
        size={"large"}
        onClose={() => setOpenSendDrawer(false)}
        open={openSendDrawer}
        penViewDrawer={{ zIndex: 99999 }}
        width="50%"
        extra={
          <Space>
            <Button onClick={() => setOpenSendDrawer(false)}>Cancel</Button>
          </Space>
        }
      >
        {openSendDrawer && <SendInvoiceDrawer instance={dataSource} />}
      </Drawer>

      {/* Product Modal Start */}
      <Drawer
        title={`${currentProductInstance ? "Edit" : "Add"} Item`}
        placement="right"
        width={"35%"}
        onClose={() => {
          setCurrentProductInstance(null);
          setOpenInvoiceItemForm(false);
          productForm.resetFields();
        }}
        open={openInvoiceItemForm}
        style={{ zIndex: 99999 }}
      >
        <InvoiceLineForm
          invoiceId={id}
          invoiceItemData={invoiceItemData}
          setInvoiceItemData={setInvoiceItemData}
          taxRates={taxRates}
          instance={currentProductInstance}
          form={productForm}
          reload={() => {
            setCurrentProductInstance(null);
            setOpenInvoiceItemForm(false);
            productForm.resetFields();
          }}
        />
      </Drawer>
      {/* Product Modal End */}

      {/* Service Modal Start */}
      <Drawer
        title={`${currentServiceInstance ? "Edit" : "Add"} Service`}
        placement="right"
        width={"35%"}
        onClose={() => {
          setCurrentServiceInstance(null);
          setOpenServiceForm(false);
          serviceForm.resetFields();
        }}
        open={openServiceForm}
        style={{ zIndex: 99999 }}
      >
        <InvoiceServiceForm
          invoiceId={id}
          serviceData={serviceData}
          setServiceData={setServiceData}
          taxRates={taxRates}
          instance={currentServiceInstance}
          form={serviceForm}
          reload={() => {
            setCurrentServiceInstance(null);
            setOpenServiceForm(false);
            serviceForm.resetFields();
          }}
        />
      </Drawer>
      {/* Service Modal End */}
      <Drawer
        title={`Invoice Details - ${dataSource?.inv_number ?? ""}`}
        placement="right"
        onClose={() => setOpenViewDrawer(false)}
        open={openViewDrawer}
        width={"50%"}
        extra={
          <PreviewDrawerActions
            onPrint={
              dataSource && !isManual
                ? () => {
                    if (pdfUrl) {
                      const printWindow = window.open(pdfUrl);
                      if (printWindow) {
                        printWindow.addEventListener('load', () => {
                          printWindow.print();
                        });
                      }
                    }
                  }
                : undefined
            }
            printDisabled={!pdfUrl || pdfLoading}
            onDownload={
              dataSource && !isManual
                ? () => previewDownloadPdf(false, true)
                : undefined
            }
            onClose={() => setOpenViewDrawer(false)}
          />
        }
      >
        {/* Render invoice details here */}
        {/* Embed PDF */}
        {pdfLoading ? (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            <Spin size="large" />
          </div>
        ) : pdfUrl && (
          <PdfViewer
            url={pdfUrl}
            title="Invoice PDF"
            onDownload={() => previewDownloadPdf(false, true)}
          />
        )}
      </Drawer>

      {/* Clone Invoice Dialog */}
      <CloneInvoiceDialog
        visible={cloneDialogVisible}
        onClose={() => setCloneDialogVisible(false)}
        invoice={dataSource}
        onSuccess={handleCloneSuccess}
      />

      {/* Import Invoice Lines Modal */}
      <ImportInvoiceLinesModal
        open={importModalOpen}
        onClose={() => setImportModalOpen(false)}
        onImport={handleImportInvoiceLines}
        onExport={handleExportInvoiceLines}
        taxRates={taxRates}
        invoiceId={id}
        canExport={!!id && invoiceItemData.length > 0}
      />

      {/* Schedule Reminder Modal */}
      <ScheduleReminderModal
        visible={scheduleReminderModalOpen}
        onClose={() => setScheduleReminderModalOpen(false)}
        onSave={(reminders, contacts) => {
          setScheduledReminders(reminders);
          setReminderContacts(contacts);
          setScheduleReminderModalOpen(false);
        }}
        paymentTermId={mainForm.getFieldValue('payment_term')}
        invoiceDueDate={mainForm.getFieldValue('due_date')}
        invoiceId={id}
        existingReminders={scheduledReminders}
        existingContacts={reminderContacts}
        invoiceDisplay={dataSource?.inv_number || 'New Invoice'}
      />

      {/* Quick Add Account Modal */}
      <QuickAddAccountModal
        open={quickAddAccountOpen}
        onCancel={() => setQuickAddAccountOpen(false)}
        onCreated={onQuickAccountCreated}
      />
    </div>
  );
};
export default InvoiceForm;
